import styled from 'styled-components';

const Container = styled.div`
  margin-top: 40px;
  padding: 0;
  width: 100%;
  > div > div {
    box-shadow: none !important;
  }
  .slick-list {
    overflow: visible;
  }
  .column-inner-container {
    width: 100% !important;
  }
  .hero-subscribe-form {
    padding: 0;
    .MuiFormControl-fullWidth {
      width: fit-content;
    }
  }
  .section-hero--notification {
    text-align: center;
  }
  .data-layer-form {
    justify-content: center;
    margin: 0 0 24px;

    .form-item.form-field.Email {
      width: 314px;
      max-width: 100%;
    }
    .form-field:first-child {
      width: 100%;
      max-width: 314px;
    }
    .signup-form-hp123-item {
      margin-bottom: 0 !important;
    }
    .form-item {
      margin-right: 0px;
      label {
        top: 3px;
      }
      input {
        height: 26px !important;
      }
    }

    .form-field button {
      padding: 15px 24px;
      min-width: 184px;
      margin-left: 16px !important;
      font-size: 20px;
      height: 100%;
      line-height: inherit;
      white-space: nowrap;
      &:hover {
        box-shadow: none;
      }

      &:disabled {
        background-color: var(--grey-3) !important;
        color: var(--grey-6);
      }
    }
    @media (max-width: 767px) {
      flex-direction: column;
      .form-field button {
        margin-left: 0px !important;
      }
      .form-field {
        width: 100%;
        margin-bottom: 12px;

        &:first-child {
          max-width: 100%;
        }
      }

      .form-item.form-field.Email {
        width: 100%;
        max-width: 100%;
      }

      .form-item {
        label {
          top: 1px;
        }
        input {
          height: 20px !important;
        }
      }
      button {
        font-size: var(--font-size-18) !important;
        padding: 11px;
        margin-left: 0;
      }
    }
    @media (max-width: 575px) {
      .text-field-wrapper .text-field-input {
        height: 45px !important;
      }

      .form-field button {
        height: 55px;
      }
    }
  }
  .hero-subscribe-form--legal-info {
    opacity: 1;
    width: 500px;
    margin: 0 auto;

    p {
      text-align: center;
      color: ${({ theme }) => (theme === 'light' ? 'var(--white)' : 'var(--darkest)')};
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 0;
    margin-top: 0px;

    .form-field:first-child,
    .hero-subscribe-form--legal-info {
      width: 100%;
    }
    .data-layer-form {
      margin: 0 !important;
      padding: 0 !important;
    }
    .hero-subscribe-form-container {
      margin-top: 0;
    }
  }
`;

export { Container };
